import { all, fork } from 'redux-saga/effects';

import authSaga from 'pages/auth/redux/sagas';
import appSaga from 'pages/app/redux/sagas';

export default function* rootSaga() {
  yield all([fork(authSaga)]);
  yield all([fork(appSaga)]);
}
